import { Box, Typography } from '@mui/material'
import i18n from 'i18n'
import { ReactNode } from 'react'
import { theme } from 'theme'

interface TitleWithIconRowProps {
  icon: ReactNode
  title: string
  id?: string
}

export default function TitleWithIconRow(props: TitleWithIconRowProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'start'
      }}
    >
      <Box mt={0.5}>{props.icon}</Box>
      <Typography
        id={props.id}
        ml={i18n.dir() === 'ltr' ? 1 : undefined}
        mr={i18n.dir() === 'rtl' ? 1 : undefined}
        mb={1}
        fontWeight={300}
        fontSize={14}
      >
        {props.title}
      </Typography>
    </Box>
  )
}
